import { useEffect, useState } from 'react';

import { ApiData } from 'scenes/common/types';
import {
  makeApiSuccess,
  makeApiError,
  getApiData,
  isApiError,
} from 'scenes/common/helpers/apiData';
import { useFunnelState } from 'scenes/common/contexts/quoteFlowContext';
import { MotorFunnelState } from 'scenes/motor/types';
import analytics from 'scenes/motor/analytics';

import { vehicleApi } from 'scenes/motor/api';
import { VehicleData, Make } from 'scenes/motor/api/vehicle/types';

export const useVehicle = (): ApiData<VehicleData> => {
  const funnelState = useFunnelState<MotorFunnelState>();

  const [makes, setMakes] = useState<Make[]>([]);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let componentMounted = true;
    const vehicleApiInstance = vehicleApi();

    vehicleApiInstance.getMakes().then((makesData) => {
      if (componentMounted) {
        if (isApiError(makesData)) {
          analytics().error(
            funnelState,
            `Vehicle makes: ${makesData.errorReason?.message || ''}`,
            makesData.errorReason?.type
          );
          setHasError(true);
        } else {
          setMakes(getApiData(makesData));
        }
      }
    });

    return () => {
      componentMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return hasError
    ? makeApiError(`Can't get vehicle makes`)
    : makeApiSuccess({
        makes,
      });
};
